import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { staffName } from '../utils/format';
import './Navigation.css';

function Navigation({ onLogout, onFeedback }) {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    authAPI
      .me()
      .then((user) => {
        if (!cancelled) setCurrentUser(user);
      })
      .catch(() => {
        /* 401s are handled by the axios interceptor (redirect to login) */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-logo" onClick={() => navigate('/dashboard')}>
          <img src="/images/wylie-logo.png" alt="Wylie Logo" className="nav-logo-img" />
          <h2 className="nav-logo-text">Wylie Recruit</h2>
        </div>
        <ul className="nav-menu">
          <li onClick={() => navigate('/candidates')}>Candidates</li>
          <li onClick={() => window.open('/GOOGLE_DRIVE_TEMPLATES.html', '_blank')}>Templates & Folders</li>
          <li onClick={() => navigate('/help')}>Help</li>
          {currentUser?.is_admin && (
            <li onClick={() => navigate('/users')}>Users</li>
          )}
          <li className="feedback-button" onClick={onFeedback}>F/B</li>
          {currentUser && (
            <li className="nav-user" title={currentUser.email}>
              {staffName(currentUser.full_name)}
            </li>
          )}
          <li className="logout-button" onClick={handleLogout}>Logout</li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
